import { render, staticRenderFns } from "./realTimeVideoGBHegu.vue?vue&type=template&id=c3315540&scoped=true&"
import script from "./realTimeVideoGBHegu.vue?vue&type=script&lang=js&"
export * from "./realTimeVideoGBHegu.vue?vue&type=script&lang=js&"
import style0 from "./realTimeVideoGBHegu.vue?vue&type=style&index=0&id=c3315540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3315540",
  null
  
)

export default component.exports